import React from 'react';
import './GenderProgressChart.css';

const GenderProgressChart = ({
  maleValue,
  femaleValue,
  showPercentage = true,
}) => {
  const total = maleValue + femaleValue;
  const malePercentage = total > 0 ? (maleValue / total) * 100 : 0;
  const femalePercentage = total > 0 ? (femaleValue / total) * 100 : 0;

  return (
    <div className="gender-progress-container">
      <div className="header">
        <div className="gender-info male-info">
          <span className="gender-icon male-icon">♂</span>
          <span className="gender-label">男性</span>
        </div>

        <div className="gender-info female-info">
          <span className="gender-label">女性</span>
          <span className="gender-icon female-icon">♀</span>
        </div>
      </div>

      {/* 单个进度条容器 */}
      <div className="single-progress-container">
        {/* 男性部分（左侧） */}
        <div
          className="progress-segment male-segment"
          style={{ width: `${malePercentage}%` }}
        >
          {showPercentage && malePercentage > 8 && (
            <div className="segment-percentage male-percentage">
              {malePercentage.toFixed(1)}%
            </div>
          )}
        </div>

        {/* 女性部分（右侧） */}
        <div
          className="progress-segment female-segment"
          style={{ width: `${femalePercentage}%` }}
        >
          {showPercentage && femalePercentage > 8 && (
            <div className="segment-percentage female-percentage">
              {femalePercentage.toFixed(1)}%
            </div>
          )}
        </div>

        {/* 中间分隔线 */}
        {malePercentage > 0 && femalePercentage > 0 && (
          <div
            className="segment-divider"
            style={{ left: `${malePercentage}%` }}
          ></div>
        )}

        {/* 外部显示的百分比（当百分比太小时） */}
        {showPercentage && (
          <>
            {malePercentage <= 8 && (
              <div
                className="outside-percentage male-outside"
                style={{ left: `${malePercentage / 2}%` }}
              >
                {malePercentage.toFixed(1)}%
              </div>
            )}
            {femalePercentage <= 8 && (
              <div
                className="outside-percentage female-outside"
                style={{ right: `${femalePercentage / 2}%` }}
              >
                {femalePercentage.toFixed(1)}%
              </div>
            )}
          </>
        )}
      </div>

      <div className="progress-track">
        <div className="track-start">0%</div>
        <div className="track-middle">50%</div>
        <div className="track-end">100%</div>
      </div>
    </div>
  );
};

GenderProgressChart.defaultProps = {
  maleValue: 1500,
  femaleValue: 1200,
  showPercentage: true,
};

export default GenderProgressChart;
